module.exports = __webpack_public_path__ + "static/img/img_love.a5414878.c37d5c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img_love.a5414878.png
// module id = /8Ow
// module chunks = 0